import { omit } from "lodash";

export const calcFiltersLength = ({ fields, strings, numbers, availability }) =>
  Object.values({ ...omit(fields, "term"), ...strings, ...numbers, availability }).filter(
    (value) => value !== "" && value !== null && value !== undefined && value.length !== 0
  ).length;
